module.exports = __webpack_public_path__ + "static/media/bottom_banner_1_1.27089dc2.png";